import React from 'react';
import { InjectedRouter } from 'react-router';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import CurrentUser from 'auth/CurrentUser';

import GetCoachingHomeDashboard from 'coaching/containers/GetCoachingHomeDashboard';
import CoachingHomeView from 'coaching/components/CoachingHomeView/CoachingHomeView';
import DeprecatedCoachingHomeView from 'coaching/components/DeprecatedCoachingHomeView/CoachingHomeView';
import ErrorReporter from 'app/components/ErrorReporter';
import { withRouter } from 'app/context/Router';

export function CoachingHomeContainer({ router }: { router: InjectedRouter }) {
  const currentUser = CurrentUser.getUser();
  return (
    <GetCoachingHomeDashboard>
      {({ coachingHomeDashboard, loading, error }) => {
        if (loading) {
          return <CenteredLoadingIndicator />;
        }
        if (!coachingHomeDashboard || error) {
          return <ErrorReporter error={`Could not load coaching home dashboard e=${error}`} />;
        }

        return currentUser?.hasFeature('coaching_home_v2_scheduling.web.apr-21') ? (
          <CoachingHomeView coachingHomeDashboard={coachingHomeDashboard} router={router} />
        ) : (
          <DeprecatedCoachingHomeView
            coachingHomeDashboard={coachingHomeDashboard}
            router={router}
          />
        );
      }}
    </GetCoachingHomeDashboard>
  );
}

export default withRouter(CoachingHomeContainer);
